export default __webpack_public_path__ + "static/media/S2xCLUE2.3957ef71.jpg";